import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Header } from './components/Header';
import { Footer } from './components/Footer';
import { ScrollToTop } from './components/ScrollToTop';
import { ExitIntentPopup } from './components/ExitIntentPopup';
import { HomePage } from './pages/HomePage';
import { AboutPage } from './pages/AboutPage';
import { ServicesPage } from './pages/ServicesPage';
import { ServiceDetailPage } from './pages/ServiceDetailPage';
import { FeesPage } from './pages/FeesPage';
import { BlogPage } from './pages/BlogPage';
import { ContactPage } from './pages/ContactPage';
import { BookingPage } from './pages/BookingPage';
export function App() {
  return <BrowserRouter data-id="element-0">
      <ScrollToTop data-id="element-1" />
      <div className="min-h-screen flex flex-col font-sans text-charcoal bg-cream" data-id="element-2">
        <Header data-id="element-3" />
        <main id="main-content" className="flex-grow" data-id="element-4">
          <Routes data-id="element-5">
            <Route path="/" element={<HomePage data-id="element-7" />} data-id="element-6" />
            <Route path="/about" element={<AboutPage data-id="element-9" />} data-id="element-8" />
            <Route path="/services" element={<ServicesPage data-id="element-11" />} data-id="element-10" />
            <Route path="/services/:id" element={<ServiceDetailPage data-id="element-13" />} data-id="element-12" />
            <Route path="/fees" element={<FeesPage data-id="element-15" />} data-id="element-14" />
            <Route path="/blog" element={<BlogPage data-id="element-17" />} data-id="element-16" />
            <Route path="/contact" element={<ContactPage data-id="element-19" />} data-id="element-18" />
            <Route path="/booking" element={<BookingPage data-id="element-21" />} data-id="element-20" />
          </Routes>
        </main>
        <Footer data-id="element-22" />
        <ExitIntentPopup data-id="element-23" />
      </div>
    </BrowserRouter>;
}